export default __webpack_public_path__ + "01c5a7e.png";